import Vue from "vue";
import { IonicVueRouter } from "@ionic/vue";

Vue.use(IonicVueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue")
  },
  {
    path: "/asset/:share_code",
    name: "Asset",
    component: () => import("../views/Asset.vue")
  },
  {
    path: "/form/:share_code",
    name: "Form",
    component: () => import("../views/Form.vue")
  },
  {
    path: "*",
    redirect: "/"
  }
];

export const router = new IonicVueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
